module.exports = __webpack_public_path__ + "images/directory/featured-hero/corrello.07de2634dd2e1351f1f1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/corrello.png
// module id = oIJ8
// module chunks = 2